import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IChallenge, IChallengesState } from ".";

interface IGetChallengesResponse {
    challenges: IChallenge[];
    tutorial?: {
        completed: number;
        total: number;
    }
}

export const getChallenges = createAsyncThunk<IGetChallengesResponse>(
    'getChallenges',
    async () => await api.challenges.get()
);

const getChallengesHandler = (builder: ActionReducerMapBuilder<IChallengesState>) => {
    builder
        .addCase(getChallenges.pending, (state: IChallengesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getChallenges.fulfilled, (state: IChallengesState, action: PayloadAction<IGetChallengesResponse>) => {
            state.loading = false;
            state.tutorial = action.payload?.tutorial;
            state.items = action.payload?.challenges
                .sort((a, b) => {
                    const categoryDiff = a.category - b.category;
                    if (categoryDiff !== 0) {
                        return categoryDiff;
                    }
                    
                    return a.priority - b.priority;
                }) ?? [];
        })
        .addCase(getChallenges.rejected, (state: IChallengesState) => {
            state.loading = false;
            state.error = 'Unable to get challenges';
        });
};

export default getChallengesHandler;